<ul
  class="bn-toastr"
  (mouseenter)="setStackHovered(true)"
  (mouseleave)="setStackHovered(false)">
  <!-- toastsList is capped to MAX_VISIBLE_TOASTS at insert time and ordered newest first — the styles pile them up, front to back -->
  @for (toast of toastsList; track trackByToastId(i, toast); let i = $index) {
    <li class="bn-toastr__toast">
      <bn-web-ui-toast-component
        [canAutohide]="i === 0 && !isStackHovered"
        [config]="toast.config"
        [externalLink]="toast.externalLink"
        [headerIcon]="toast.headerIcon"
        [title]="toast.title"
        [toastId]="toast.toastId"
        [type]="toast.type"
        (disposeEvent)="dispose(i)">
        <div [innerHTML]="toast.message | sanitizeHtml: ['p', 'br', 'span', 'strong', 'b', 'em', 'i']"></div>
      </bn-web-ui-toast-component>
    </li>
  }
</ul>
